<template>
	<div class="no-select" v-cloak>
		<div class="row">
			<div class="col-12 col-promo-ask" v-show="show.ask">
				<span class="span-promo-ask" @click="showDiv(DIV_APPLY)">PROMO CODE?</span>
			</div>
			<div class="col-12 col-promo-application" v-show="show.apply">
				<label class="label-promo-apply" for="input-promo-apply">Promo Code</label>
				<input id="input-promo-apply" ref="inputPromoApply" type="text" class="form-control" placeholder="Enter promo code" v-model="code" @keypress.enter.prevent="getVoucherByCode()" :disabled="requestsActive" />
				<div class="div-promo-application-controls">
					<span class="span-promo-apply" @click="getVoucherByCode()">APPLY PROMO</span>
					<span class="span-promo-apply-invalid" v-show="feedback.invalid">Invalid.</span>
					<span class="span-promo-apply-expired" v-show="feedback.expired">Expired.</span>
					<img class="img-button-close" src="/img/icons/close-light-gray-25.png" @click="showDiv(DIV_ASK)" v-show="!requestsActive" />
					<img class="img-loader-icon" src="/img/loaders/spinner-1s-200px-purple.svg" v-show="requestsActive" />
				</div>
			</div>
			<div class="col-12 col-promo-applied" v-show="show.applied">
				<span class="span-promo-applied">Promo Code</span>
				<div class="div-promo-applied">
					<img class="img-valid-promo-code" src="/img/icons/valid-30.png" />
					<span class="span-promo-applied-code">{{code}}</span>
				</div>
				<span class="span-promo-applied-code-remove" @click="removeCode();">Remove code</span>
			</div>
		</div>
	</div>
</template>




<script>
	export default {
		mixins: [mixinAxios],
		data: () => ({
			code : '',
			voucher : {},
			show: {
				ask : true,
				apply : false,
				applied : false,
				invalid : false,
				expired : false
			},
			feedback: {
				invalid: false,
				expired: false
			}
		}),
		props: {
		},
		created() {
			this.DIV_ASK = 0;
			this.DIV_APPLY = 1;
			this.DIV_APPLIED = 2;
		},
		mounted() {
		},
		methods: {
			getVoucherByCode() {
				this.codeToUpper();

				this.clearFeedback();

				var params = { params : {
					code : this.code
				}};

				var reqGetVoucher = this.mixinAxios().get('/api/user/GetVoucherByCode', params).then((resGetVoucher) => {
					this.voucher = resGetVoucher.data;

					if (this.voucher == '') {
						this.clearVoucher();
						this.feedback.invalid = true;
					} else if (this.voucher.expired) {
						this.clearVoucher();
						this.feedback.expired = true;
					} else { // voucher valid and not expired
						this.showDiv(this.DIV_APPLIED);
						this.$emit('code-applied', this.voucher);
					}
				});
			},
			codeToUpper() {
				this.code = this.code.toUpperCase();
			},
			clearShowFlags() {
				this.show.ask = false;
				this.show.apply = false;
				this.show.applied = false;
			},
			clearFeedback() {
				this.feedback.invalid = false;
				this.feedback.expired = false;
			},
			clearVoucher() {
				this.code = '';
				this.voucher = {};

				this.$refs.inputPromoApply.focus();
			},
			showDiv(section) {
				this.clearShowFlags();
				this.clearFeedback();

				switch (section) {
					case this.DIV_ASK:		this.show.ask = true;
											break;

					case this.DIV_APPLY:	this.show.apply = true;
											Vue.nextTick(() => { this.$refs.inputPromoApply.focus(); });
											break;

					case this.DIV_APPLIED:	this.show.applied = true;
											break;
				}
			},
			removeCode() {
				this.clearVoucher();
				this.showDiv(this.DIV_ASK);
				this.$emit('code-removed', this.voucher);
			}
		}
	};
</script>




<style scoped>
	[v-cloak] {
		display:none;
	}

	.span-promo-ask, .span-promo-apply {
		cursor:pointer;
		text-decoration:underline;
		font-weight:bold;
		font-size:0.9em;
		color:#8c8c8c;
	}

	.label-promo-apply {
		font-weight:bold;
		color:#8c8c8c;
		font-size:0.9em;
		display:none;
	}

	#input-promo-apply {
		color:#555555;
		margin:5px 0px;
		height:30px;
	}

	#input-promo-apply:focus {
		border-color:#3d9700;
		box-shadow: none;
	}

	.span-promo-apply-invalid, .span-promo-apply-expired {
		margin-left:15px;
		color:red;
		font-size:0.9em;
	}

	.span-promo-applied {
		font-weight:bold;
		color:#8c8c8c;
		font-size:0.9em;
		display:none;
	}

	.span-promo-applied-code {
		color:green;
		font-weight:bold;
		margin-left:7px;
	}

	.span-promo-applied-code-remove {
		color:gray;
		font-size:0.9em;
		cursor:pointer;
	}

	.div-promo-application-controls {
		display:flex;
		align-items:center;
	}

	.img-button-close, .img-loader-icon {
		height:16px;
		cursor:pointer;
		margin-left:auto;
	}

	.img-valid-promo-code {
		height:16px;
	}

	.div-promo-applied {
		display:flex;
		align-items:center;
	}

</style>